import React from 'react';
import PropTypes from 'prop-types';
import Carousel3D from '@/components/carousel-3d';
import TVSlide from './tv-slide';
import Button from '@gerenciatd/next.components.button-n'
import TextInfo from '@gerenciatd/next.components.text-info-n';

const SUB_COMPONENT = 'TvSlide';

const slidesInfoRendered = (props, minHeight, custoObjectInfo) =>  {
  let componentKeys = Object.keys(props);
  componentKeys = componentKeys.filter(item => (item.indexOf(SUB_COMPONENT) > -1));
  return componentKeys.map((keySlide) => {
    let tvSlideCustoObjectInfo = null;
    if (custoObjectInfo) {
      tvSlideCustoObjectInfo = custoObjectInfo.addEntryPoint({
        custoObjectInfo,
        entryPoint: `${keySlide}`,
      })
    }
    const currentSlideProps = props[keySlide];

    return (
        <TVSlide
          {...currentSlideProps}
          minHeight={minHeight}
          custoObjectInfo={tvSlideCustoObjectInfo}
        />
    )
  })
}

const TvSlider = (props) => {
  const { bgColor, minHeight, taggingInfo, custoObjectInfo } = props;
  const cssBgColor = `var(--color-gp--${bgColor})`;
  let textInfoCustoObjectInfo1 = null;
  let buttonCustoObjectInfo1 = null;
  if (custoObjectInfo) {
    textInfoCustoObjectInfo1 = custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: 'TextInfo-1',
    })
    buttonCustoObjectInfo1 = custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: 'Button-1',
    })
  }
  
  const slides = slidesInfoRendered(props, minHeight, custoObjectInfo);
  
  return (
    <div style={{backgroundColor: cssBgColor}} className={`tvSliderContainer ${cssBgColor}`}>
      {props['TextInfo-1'] && (
        <div className="title-gap">
          <TextInfo
            {...props['TextInfo-1']}
            custoObjectInfo={textInfoCustoObjectInfo1}
          />
        </div>
      )}
      {slides && Array.isArray(slides) && slides.length > 0 && (
        <Carousel3D
          className="carousel3d"
          minHeight={minHeight}
          slides={slides}
          taggingInfo={{
            ...taggingInfo,
            componentName: "carrusel",
          }}
          minimunSpace={50}
        />
      )}
      {props['Button-1'] && (
        <div className="button-gap">
          <Button
            {...props['Button-1']}
            custoObjectInfo={buttonCustoObjectInfo1}
          />
        </div>
      )}
      <style jsx>
        {`
        .tvSliderContainer{
            position:relative;
            padding-top:60px;
            padding-bottom:60px;
            overflow:hidden;
            .title-gap {
              margin-bottom: 2rem;
            }
            .button-gap {
              width: 100%;
              max-width: 12rem;
              margin: 2rem auto;
              min-width: 190px;
            }
          }
        `}
      </style>
    </div>
  )
}

TvSlider.propTypes = {
  minHeight: PropTypes.number,
  heightResizable: PropTypes.bool,
}

TvSlider.defaultProps = {
  minHeight: 480,
  heightResizable: true,
}

export default TvSlider;